import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec" />
            <EfSection
                isVideo={true}
                loop={true}
                autoPlay={true}
                position="hover"
                theme="white"
                poster="https://websiteoss.ecoflow.com/upload/image/1721119145282/img_run%202%20ac.jpg"
                pc="https://websiteoss.ecoflow.com/upload/video/1721119205248/A%E7%BA%A7%E4%BF%AF%E8%A7%86.mp4"
                label={t('D_label')}
                title={t('D_title')}
                desc={t('D_desc')}
            />
            <EfSpec className="spec" />
        </div>
    );
}
